import { TemplateConfig } from '../types';

export const multiDimensionalThoughtsConfig: TemplateConfig = {
  id: 'multi-dimensional-thoughts',
  name: '多维度想法',
  description: '从多个维度分析TA对你的想法和感觉',
  cardCount: 5,
  
  fieldDefaults: {
    title: '多维度想法',
    customerQuestion: 'TA对我的想法和感觉',
    cardInfos: [
      '代表对方对我以及对我们的感情的表层想法',
      '代表对方对我以及对我们感情的主体想法',
      '代表对方对我以及对我们感情的潜意识想法',
      '第4张牌与第5张牌做对比。如果第4张牌为比较有利于感情的牌面，则代表天使面，也就是对方的想法中比较好的那一部分。相反，如果为比较不利于感情的牌面，则代表恶魔面，也就是对方的想法中比较差的那一部分。',
      '如果第4张牌代表天使面，则第5张牌代表恶魔面，即对方的想法中比较差的那一部分。相反，如果第4张牌代表恶魔面，则第5张牌代表天使面，即对方的想法中比较好的那一部分。'
    ],
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 3 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 3 张牌'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '🧠'
  }
};